export enum DocumentStateChangeReason {
  /** Resetting the editor to initial state. */
  Reset = 'Reset',
  /** Initial document loading. */
  Initialize = 'Initialize',
  /** Document is changed in the local editor. */
  Editor = 'Editor',
  /** Document is changed on the collab server. */
  Collab = 'Collab',
}
